/**
 *
 *
 *
 *   EDITING THIS FILE REQUIRES EDITS TO EMAIL TEMPLATE PROJECT REPO FILE AS WELL TO KEEP THEM IN SYNC
 *
 *
 *
 *
 */

import {LOCALES} from '@utils/locales/locales';

export const POST_BOOKING_APPROVAL_PENDING_TEMPLATE_DEFAULTS = {
  [LOCALES.EN]: {
    subject: 'Trip Notification - Trip Pending Approval',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Trip Notification - Trip Pending Approval',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Due to the risk classification / security situation of your destination country, your trip will be checked by the corporate security department.</div><div><br></div><div>Please “reply to all” in the e-mail and only fill in the fields below, and send the e-mail back to the sender without comment. The information provided is automatically recorded in the Crisis24 Horizon system. You will then receive further information.</div><div><br></div><div>Thank you,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Trip Info:</strong></h3><div><br></div><div><strong>Destination (site, city):</strong></div><div><strong>Trip Purpose:</strong></div><div><strong>In-Country Emergency Contact (name and mobile phone number):</strong></div><div><strong>Traveler's Mobile Phone:&nbsp;</strong></div><div><strong>Ground Transportation Details:</strong></div><div><strong>Lodging Details:&nbsp;</strong></div><div><br></div>",
      },
    ],
  },
  [LOCALES.FR]: {
    subject: "Notification de voyage - Voyage en attente d'approbation",
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: "Notification de voyage - Voyage en attente d'approbation",
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bonjour <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>En raison de la classification des risques et de la situation de sécurité de votre pays de destination, votre voyage sera contrôlé par le service de sécurité de l\'entreprise.</div> <div></div><br><div>Veuillez « répondre à tous » dans l\'e-mail et ne remplir que les champs ci-dessous, puis renvoyer l\'e-mail à l\'expéditeur sans commentaire. Les informations fournies sont automatiquement enregistrées dans le système Crisis24 Horizon. Vous recevrez ensuite de plus amples informations.</div> <div></div><br><div>Merci,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Informations sur le voyage :<div></div></strong></h3> <br><div><strong>Destination (site, ville) :</strong></div> <div><strong>But du voyage :</strong></div> Personne à <div><strong>contacter en cas d'urgence dans le pays (nom et numéro de téléphone portable) :</strong></div> <div><strong>Téléphone portable du voyageur :</strong></div> Informations sur <div><strong>le transport terrestre : Détails de l'<div><strong>hébergement</strong></div> :<div></div></strong></div> <br>",
      },
    ],
  },
  [LOCALES.ES]: {
    subject: 'Notificación de viaje: viaje pendiente de aprobación',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificación de viaje: viaje pendiente de aprobación',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span></div>:<div></div> <br><div>Debido a la clasificación de riesgos o la situación de seguridad de su país de destino, el departamento de seguridad corporativo revisará su viaje.</div> <div></div><br><div>Por favor, «responde a todas» en el correo electrónico, rellena únicamente los campos siguientes y envía el correo electrónico al remitente sin comentarios. La información proporcionada se registra automáticamente en el sistema Crisis24 Horizon. A continuación, recibirá más información</div>. <div></div><br><div>Gracias,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Información del viaje:<div></div></strong></h3> <br><div><strong>Destino (sitio, ciudad):</strong></div> <div><strong>Propósito del viaje:</strong></div> <div><strong>Contacto de emergencia dentro del país (nombre y número de teléfono móvil):</strong></div> <div><strong>Teléfono móvil del viajero:</strong></div> Detalles del <div><strong>transporte terrestre: Detalles del <div><strong>alojamiento</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.DE]: {
    subject: 'Reisemeldung — Reise steht noch aus',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Reisemeldung — Reise steht noch aus',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hallo <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>aufgrund der Risikoklassifizierung/Sicherheitslage Ihres Ziellandes wird Ihre Reise von der Sicherheitsabteilung des Unternehmens überprüft.</div> <div></div><br><div>Bitte antworten Sie in der E-Mail auf „Allen antworten“ und füllen Sie nur die folgenden Felder aus. Senden Sie die E-Mail kommentarlos an den Absender zurück. Die bereitgestellten Informationen werden automatisch im Crisis24 Horizon-System aufgezeichnet. Sie erhalten dann weitere Informationen</div>. <div></div><br><div>Danke,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Reiseinformationen:<div></div></strong></h3> <br><div><strong>Reiseziel (Ort, Stadt):</strong></div> <div><strong>Reisezweck:</strong></div> <div><strong>Notfallkontakt im Land (Name und Handynummer): <div><strong>Mobiltelefon des Reisenden</strong></div>:</strong></div> Angaben zum <div><strong>Bodentransport: Angaben zur <div><strong>Unterkunft</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.IT]: {
    subject: 'Notifica del viaggio - Viaggio in attesa di approvazione',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notifica del viaggio - Viaggio in attesa di approvazione',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Salve <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> <br><div>a<div></div> causa della classificazione del rischio/situazione di sicurezza del paese di destinazione, il viaggio verrà controllato dal dipartimento di sicurezza aziendale.</div> <div></div><br><div>Si prega di «rispondere a tutti» nell\'e-mail e compilare solo i campi sottostanti e rispedire l\'e-mail al mittente senza commenti. Le informazioni fornite vengono registrate automaticamente nel sistema Crisis24 Horizon. Riceverai quindi ulteriori informazioni</div>. <div></div><br><div>Grazie</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Informazioni sul viaggio:<div></div></strong></h3> <br><div><strong>Destinazione (sito, città):</strong></div> <div><strong>Scopo del viaggio:</strong></div> <div><strong>Contatto di emergenza nel Paese (nome e numero di cellulare):</strong></div> Telefono <div><strong>cellulare del viaggiatore:</strong></div> <div><strong>Trasporto via terra Dettagli: Dettagli dell'<div><strong>alloggio</strong></div>:<div></div></strong></div> <br>",
      },
    ],
  },
  [LOCALES.JA]: {
    subject: 'トリップ通知-トリップの承認待ち',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'トリップ通知-トリップの承認待ち',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>こんにちは <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>、<div></div></div><br><div>目的国のリスク分類/セキュリティ状況により、旅行は企業のセキュリティ部門によってチェックされます。</div><div></div><br><div>メールに「全員に返信」し、以下のフィールドのみを入力し、コメントなしで送信者にメールを送り返してください。提供された情報は、Crisis24 Horizon システムに自動的に記録されます。その後、さらに詳しい情報が届きます</div>。<div></div><br><div>ありがとうございます。</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>旅行情報:<div></div></strong></h3><br><div><strong>目的地 (サイト、都市):</strong></div> <div><strong>旅行目的:</strong></div><div><strong>国内緊急連絡先 (名前と携帯電話番号):</strong></div> <div><strong>旅行者の携帯電話:陸上交通情報:</strong></div><div><strong><div><strong>宿泊施設の詳細</strong></div>:<div></div></strong></div><br>',
      },
    ],
  },
  [LOCALES.PT]: {
    subject: 'Notificação de viagem - Viagem pendente de aprovação',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificação de viagem - Viagem pendente de aprovação',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Olá <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Devido à classificação de risco/situação de segurança do seu país de destino, sua viagem será verificada pelo departamento de segurança corporativa.</div> <div></div><br><div>Por favor, “responda a todos” no e-mail, preencha apenas os campos abaixo e envie o e-mail de volta ao remetente sem comentários. As informações fornecidas são registradas automaticamente no sistema Crisis24 Horizon. Em seguida, você receberá mais informações.</div> <div></div><br><div>Obrigado,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informações da viagem:<div></div></strong></h3> <br><div><strong>Destino (local, cidade):</strong></div> <div><strong>Objetivo da viagem:</strong></div> <div><strong>Contato de emergência no país (nome e número de celular): Telefone</strong></div> <div><strong>celular do viajante: Detalhes do transporte terrestre:</strong></div> <div><strong>Detalhes da <div><strong>hospedagem</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.ZH_HANS]: {
    subject: '行程通知-行程待批准',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '行程通知-行程待批准',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>你好 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>，<div></div></div><br><div>由于目的地国家的风险分类/安全状况，您的行程将由公司安全部门检查。</div><div></div><br><div>请在电子邮件中 “回复所有人”，仅填写以下字段，然后将电子邮件发回给发件人，不加评论。所提供的信息会自动记录在Crisis24 Horizon系统中。然后，您将收到更多信息。</div><div></div><br><div>谢谢，</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>旅行信息：<div></div></strong></h3><br><div><strong>目的地（地点、城市）：</strong></div><div><strong>旅行目的：</strong></div><div><strong>国内紧急联系人（姓名和手机号码）：</strong></div><div><strong>旅行者手机：</strong></div><div><strong>地面交通详情：</strong></div><div><strong>住宿详情</strong></div>：<div></div><br>',
      },
    ],
  },
  [LOCALES.ZH_HANT]: {
    subject: '行程通知-行程等待核准',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '行程通知-行程等待核准',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>您好 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>由於目的地國家的風險分類/安全情況，您的行程將由企業安全部檢查。</div><div></div><br><div>請在電子郵件中「回覆所有人」，只填寫以下字段，然後將電子郵件發送回發件人，而無需評論。提供的信息會自動記錄在 Crisis24 Horizon 系統中。然後，您將收到更多信息。</div><div></div><br><div>謝謝，</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>旅行信息：<div></div></strong></h3><br><div><strong>目的地（網站，城市）：</strong></div><div><strong>旅行目的：</strong></div><div><strong>國內緊急聯繫人（姓名和手機號碼）：旅客</strong></div><div><strong>的手機：地面</strong></div><div><strong>交通詳細信息：住宿<div><strong>詳情</strong></div>：<div></div></strong></div><br>',
      },
    ],
  },
  [LOCALES.RU]: {
    subject: 'Уведомление о поездке — поездка ожидает одобрения',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Уведомление о поездке — поездка ожидает одобрения',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Здравствуйте, <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span></div>! <br><div>В<div></div> связи с классификацией рисков и ситуацией с безопасностью в стране назначения ваша поездка будет проверена отделом корпоративной безопасности.</div> <div></div><br><div>Пожалуйста, «ответьте всем» в электронном письме, заполните только поля ниже и отправьте электронное письмо отправителю без комментариев. Предоставленная информация автоматически записывается в систему Crisis24 Horizon. После этого вы получите дополнительную информацию</div>. <div></div><br><div>Спасибо,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Информация о поездке:<div></div></strong></h3> <br><div><strong>Пункт назначения (место назначения, город):</strong></div> <div><strong>Цель поездки:</strong></div> <div><strong>Контактное лицо в стране (имя и номер мобильного телефона):</strong></div> <div><strong>мобильный телефон путешественника:</strong></div> информация о <div><strong>наземном транспорте: информация о <div><strong>жилье</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.HI]: {
    subject: 'ट्रिप नोटिफिकेशन - ट्रिप की लंबित स्वीकृति',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'ट्रिप नोटिफिकेशन - ट्रिप की लंबित स्वीकृति',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>नमस्ते <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> <br><div>आपके गंतव्य देश के जोखिम वर्गीकरण/सुरक्षा स्थिति के<div></div> कारण, आपकी यात्रा की जाँच कॉर्पोरेट सुरक्षा विभाग द्वारा की जाएगी।</div> <div></div><br><div>कृपया ई-मेल में “सभी को जवाब दें” और केवल नीचे दिए गए फ़ील्ड भरें, और बिना किसी टिप्पणी के प्रेषक को ईमेल वापस भेजें। प्रदान की गई जानकारी स्वचालित रूप से Crisis24 Horizon सिस्टम में दर्ज हो जाती है। इसके बाद आपको और जानकारी मिलेगी</div>। <div></div><br><div>धन्यवाद,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>यात्रा की जानकारी:<div></div></strong></h3> <br><div><strong>गंतव्य (साइट, शहर):</strong></div> <div><strong>यात्रा का उद्देश्य:</strong></div> <div><strong>देश में आपातकालीन संपर्क (नाम और मोबाइल फोन नंबर):</strong></div> <div><strong>यात्री का मोबाइल फोन: ग्राउंड ट्रांसपोर्टेशन विवरण:</strong></div> <div><strong><div><strong>आवास</strong></div> का विवरण:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.NL]: {
    subject: 'Reismelding - Reis in afwachting van goedkeuring',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Reismelding - Reis in afwachting van goedkeuring',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hallo <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>vanwege de risicoclassificatie/veiligheidssituatie van het land van bestemming wordt uw reis gecontroleerd door de afdeling bedrijfsbeveiliging.</div> <div></div><br><div>Gelieve „" iedereen te beantwoorden "” in de e-mail en alleen de onderstaande velden in te vullen en de e-mail zonder commentaar terug te sturen naar de afzender.” De verstrekte informatie wordt automatisch vastgelegd in het Crisis24 Horizon-systeem. Je krijgt dan meer informatie.</div> <div></div><br><div>Dank je wel,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Reisinformatie:<div></div></strong></h3> <br><div><strong>Bestemming (locatie, stad):</strong></div> <div><strong>Reisdoel:</strong></div> <div><strong>Contactpersoon voor noodgevallen in het land (naam en gsm-nummer):</strong></div> <div><strong>Mobiele telefoon van de reiziger:</strong></div> Gegevens over <div><strong>grondvervoer: <div><strong>Accommodatiegegevens</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.PL]: {
    subject: 'Powiadomienie o podróży - podróż oczekująca na zatwierdzenie',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Powiadomienie o podróży - podróż oczekująca na zatwierdzenie',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Witaj <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Ze względu na klasyfikację ryzyka/sytuację bezpieczeństwa w Twoim kraju docelowym, Twoja podróż zostanie sprawdzona przez dział bezpieczeństwa korporacyjnego.</div> <div></div><br><div>Prosimy „odpowiedzieć wszystkim” w e-mailu i wypełnić tylko poniższe pola i wysłać wiadomość e-mail z powrotem do nadawcy bez komentarza. Podane informacje są automatycznie rejestrowane w systemie Crisis24 Horizon. Otrzymasz wtedy dalsze informacje.</div> <div></div><br><div>Dziękuję,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informacje o podróży:</strong></h3> Miej <br><div><strong>sce<div></div> docelowe (miejsce, miasto):</strong></div> Cel <div><strong>podróży:</strong></div> <div><strong>Kontakt w nagłych wypadkach w kraju (imię i nazwisko i numer telefonu komórkowego):</strong></div> <div><strong>Telefon komórkowy podróżnika:</strong></div> <div><strong>Transport naziemny Szczegóły: <div><strong>Szczegóły zakwaterowania</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.HE]: {
    subject: '"הודעת נסיעה - נסיעה ממתינה לאישור"',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'הודעת נסיעה - נסיעה ממתינה לאישור',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>שלום <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>בשל סיווג הסיכון/מצב האבטחה של מדינת היעד שלך, הנסיעה שלך תיבדק על ידי מחלקת האבטחה הארגונית.</div> <div></div><br><div>אנא "השב לכולם" בדואר האלקטרוני ומלא רק את השדות למטה, ושלח את הדואר האלקטרוני בחזרה לשולח ללא תגובה. המידע המסופק נרשם אוטומטית במערכת Crisis24 Horizon. לאחר מכן תקבל מידע נוסף.</div> <div></div><br><div>תודה,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>מידע על טיול:<div></div></strong></h3> <br><div><strong>יעד (אתר, עיר): מט</strong></div> <div><strong>רת טיול:</strong></div> <div><strong>איש קשר לשעת חירום במדינה (שם ומספר טלפון נייד):</strong></div> <div><strong>טלפון נייד של הנוסע: פרטי</strong></div> <div><strong>תחבורה קרקעית: <div><strong>פרטי לינה</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.TR]: {
    subject: 'Yolculuk Bildirimi - Yolculuk Onay Bekliyor',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Yolculuk Bildirimi - Yolculuk Onay Bekliyor',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Merhaba <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Hedef ülkenizin risk sınıflandırması/güvenlik durumu nedeniyle seyahatiniz kurumsal güvenlik departmanı tarafından kontrol edilecektir.</div> <div></div><br><div>Lütfen e-postada “herkese cevap ver” ve sadece aşağıdaki alanları doldurun ve e-postayı yorum yapmadan gönderene geri gönderin. Sağlanan bilgiler otomatik olarak Crisis24 Horizon sistemine kaydedilir. Daha sonra daha fazla bilgi alacaksınız.</div> <div></div><br><div>Teşekkür ederim</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Gezi Bilgisi:<div></div></strong></h3> <br><div><strong>Hedef (site, şehir):</strong></div> <div><strong>Seyahat Amacı:</strong></div> <div><strong>Ülke İçi Acil Durum İletişim (isim ve cep telefonu numarası): Yolcunun Cep Telefonu:</strong></div> <div><strong>Kara Taşımac</strong></div> <div><strong>ılığı Detayları: Konaklama <div><strong>Detayları</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.KO]: {
    subject: '여정 통지 - 여정 승인 보류',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '여정 통지 - 여정 승인 보류',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>안녕하세요 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> <br><div>목적지 국가의 위험 분류/보안<div></div> 상황으로 인해 기업 보안 부서에서 여행을 확인합니다.</div><div></div><br><div>이메일에서 “전체 회신”하고 아래 필드만 기입한 후 의견 없이 발신자에게 이메일을 다시 보내주십시오.제공된 정보는 Crisis24 Horizon 시스템에 자동으로 기록됩니다.그러면 추가 정보를 받게 됩니다</div>.<div></div><br><div>감사합니다.</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>여행 정보:<div></div></strong></h3> <br><div><strong>목적지 (장소, 도시):</strong></div> <div><strong>여행 목적:</strong></div> <div><strong>국내 비상 연락처 (이름 및 휴대폰 번호):</strong></div> <div><strong>여행자 휴대폰: 지상 교통 정보:</strong></div> <div><strong><div><strong>숙박</strong></div> 세부 정보:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.EL]: {
    subject: 'Ειδοποίηση ταξιδιού - Εκκρεμεί έγκριση ταξιδιού',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Ειδοποίηση ταξιδιού - Εκκρεμεί έγκριση ταξιδιού',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Γεια σας <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Λόγω της ταξινόμησης κινδύνου/κατάστασης ασφάλειας της χώρας προορισμού σας, το ταξίδι σας θα ελεγχθεί από το τμήμα εταιρικής ασφάλειας.</div> <div></div><br><div>Παρακαλώ «απαντήστε σε όλους» στο e-mail και συμπληρώστε μόνο τα παρακάτω πεδία και στείλτε το e-mail πίσω στον αποστολέα χωρίς σχόλιο. Οι πληροφορίες που παρέχονται καταγράφονται αυτόματα στο σύστημα Crisis24 Horizon. Στη συνέχεια, θα λάβετε περισσότερες πληροφορίες.</div> <div></div><br><div>Ευχαριστώ,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Πληροφορίες ταξιδιού: Προ<div></div></strong></h3> <br><div><strong>ορισμός (ιστότοπος, πόλη): Σκοπ</strong></div> <div><strong>ός ταξιδιού:</strong></div> Επείγουσα <div><strong>επαφή εντός της χώρας (όνομα και αριθμός κινητού τηλεφώνου):</strong></div> Κινητό τηλέφωνο <div><strong>ταξιδιώτη: Στοιχεία χερ</strong></div> <div><strong>σαίας μεταφοράς: Λεπ <div><strong>τομέρειες διαμονής</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.VI]: {
    subject: 'Thông báo chuyến đi - Chuyến đi đang chờ phê duyệt',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Thông báo chuyến đi - Chuyến đi đang chờ phê duyệt',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Xin chào <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div> Do</div> <br><div>phân loại rủi ro/tình hình an ninh của quốc gia đích của bạn, chuyến đi của bạn sẽ được kiểm tra bởi bộ phận an ninh của công ty.</div> <div></div><br><div>Vui lòng “trả lời tất cả” trong e-mail và chỉ điền vào các trường bên dưới, và gửi e-mail trở lại người gửi mà không cần bình luận. Thông tin được cung cấp được tự động ghi lại trong hệ thống Crisis24 Horizon. Sau đó, bạn sẽ nhận được thêm thông tin.</div> <div></div><br><div>Cảm ơn bạn</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Thông tin chuyến đi:<div></div></strong></h3> <br><div><strong>Điểm đến (trang web, thành phố): Mục</strong></div> <div><strong>đích chuyến đi:</strong></div> Liên <div><strong>hệ khẩn cấp trong nước (tên và số điện thoại di động): Điện</strong></div> <div><strong>thoại di động của du khách: Giao</strong></div> <div><strong>thông mặt đất Chi tiết: Chi <div><strong>tiết chỗ ở</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.CS]: {
    subject: 'Oznámení o jízdě - cesta čeká na schválení',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámení o jízdě - cesta čeká na schválení',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Dobrý den <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Vzhledem k klasifikaci rizik/bezpečnostní situaci ve vaší cílové zemi bude vaše cesta zkontrolována podnikovým bezpečnostním oddělením.</div> <div></div><br><div>V e-mailu prosím „odpovězte všem“ a vyplňte pouze níže uvedená pole a pošlete e-mail zpět odesílateli bez komentáře. Poskytnuté informace jsou automaticky zaznamenány v systému Crisis24 Horizon. Poté obdržíte další informace.</div> <div></div><br><div>Děkuji,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informace o cestě:<div></div></strong></h3> <br><div><strong>Cíl (web, město): Úč</strong></div> <div><strong>el cesty:</strong></div> <div><strong>Nouzový kontakt v zemi (jméno a číslo mobilního telefonu):</strong></div> Mobilní telefon <div><strong>cestujícího: Pozemní</strong></div> <div><strong>doprava Podrobnosti: Podrobnosti o <div><strong>ubytování</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.HU]: {
    subject: 'Utazási értesítés - Utazás jóváhagyásig',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Utazási értesítés - Utazás jóváhagyásig',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Helló <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> <br><div>A célország kockázatosztályozása/biztonsági helyzete<div></div> miatt utazását a vállalati biztonsági osztály ellenőrzi.</div> <div></div><br><div>Kérjük, hogy „válaszoljon mindenkinek” az e-mailben, és csak az alábbi mezőket töltse ki, és megjegyzés nélkül küldje vissza az e-mailt a feladónak. A megadott információkat automatikusan rögzítik a Crisis24 Horizon rendszerben. Ezután további információkat kap.</div> <div></div><br><div>Köszönöm,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Utazási információk:</strong></h3> Ú<div></div> <br><div><strong>ti cél (helyszín, város):</strong></div> Uta <div><strong>zás célja:</strong></div> Országon bel <div><strong>üli sürgősségi kapcsolattartó (név és mobiltelefon száma):</strong></div> Uta <div><strong>zó mobiltelefonja:</strong></div> Földi köz <div><strong>lekedés Részletek:</strong></div> Szállás <div><strong>részlet</strong></div> ei:<div></div> <br>',
      },
    ],
  },
  [LOCALES.MS]: {
    subject: 'Pemberitahuan Perjalanan - Perjalanan Tunggu Kelulusan',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pemberitahuan Perjalanan - Perjalanan Tunggu Kelulusan',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> Oleh<div></div> <br><div>kerana klasifikasi risiko/keadaan keselamatan negara destinasi anda, perjalanan anda akan diperiksa oleh jabatan keselamatan korporat.</div> <div></div><br><div>Sila “balas kepada semua” dalam e-mel dan hanya isi medan di bawah, dan hantar e-mel kembali kepada pengirim tanpa komen. Maklumat yang diberikan direkodkan secara automatik dalam sistem Crisis24 Horizon. Anda kemudian akan menerima maklumat lanjut.</div> <div></div><br><div>Terima kasih,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Maklumat Perjalanan:<div></div></strong></h3> <br><div><strong>Destinasi (tapak, bandar): Tu <div><strong>juan perjalanan</strong></div>:</strong></div> Hu <div><strong>bungan Kecemasan Dalam Negara (nama dan nombor telefon bimbit): Telefon <div><strong>bimbit pengembara</strong></div>:</strong></div> Peng <div><strong>angkutan Darat Butiran:</strong></div> Maklumat Peng <div><strong>in</strong></div> apan:<div></div> <br>',
      },
    ],
  },
  [LOCALES.RO]: {
    subject: 'Notificare călătorie - Călătorie în așteptarea aprobării',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificare călătorie - Călătorie în așteptarea aprobării',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bună ziua <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Datorită clasificării riscurilor /situației de securitate din țara dvs. de destinație, călătoria dvs. va fi verificată de departamentul de securitate corporativă.</div> <div></div><br><div>Vă rugăm să „răspundeți tuturor” în e-mail și să completați doar câmpurile de mai jos și să trimiteți e-mailul înapoi expeditorului fără comentarii. Informațiile furnizate sunt înregistrate automat în sistemul Crisis24 Horizon. Veți primi apoi informații suplimentare.</div> <div></div><br><div>Mulțumesc,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informații despre călătorie:<div></div></strong></h3> <br><div><strong>Destinație (site, oraș):</strong></div> <div><strong>Scopul călătoriei:</strong></div> <div><strong>Contact de urgență în țară (nume și număr de telefon mobil):</strong></div> <div><strong>Telefon mobil al călătorului:</strong></div> <div><strong>Transport terestru Detalii: <div><strong>Detalii cazare</strong></div>:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.SK]: {
    subject: 'Oznámenie o ceste - Cesta čaká na schválenie',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámenie o ceste - Cesta čaká na schválenie',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Dobrý deň <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div> Vz<div></div> <br><div>hľadom na klasifikáciu rizík a bezpečnostnú situáciu vo vašej cieľovej krajine bude vaša cesta skontrolovaná oddelením firemnej bezpečnosti.</div> <div></div>V <br><div>e-maile prosím „odpovedať všetkým“ a vyplniť iba nižšie uvedené polia a pošlite e-mail späť odosielateľovi bez komentára. Poskytnuté informácie sa automaticky zaznamenávajú v systéme Crisis24 Horizon. Potom dostanete ďalšie informácie.</div> <div></div><br><div>Ďakujem,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informácie o ceste:<div></div></strong></h3> <br><div><strong>Destinácia (miesto, mesto):</strong></div> Účel <div><strong>cesty:</strong></div> <div><strong>Núdzový kontakt v krajine (meno a číslo mobilného telefónu):</strong></div> <div><strong>Mobilný telefón cestujúceho:</strong></div> Po <div><strong>zemná doprava Podrobnosti: Podrobnosti o</strong></div> <div><strong>ubyto</strong></div> vaní:<div></div> <br>',
      },
    ],
  },
  [LOCALES.TH]: {
    subject: 'แจ้งการเดินทาง - การเดินทางที่รอการอนุมัติ',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'แจ้งการเดินทาง - การเดินทางที่รอการอนุมัติ',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>สวัสดี <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span><div></div> เนื่องจากการ</div> <br><div>จำแนกความเสี่ยง/สถานการณ์ความปลอดภัยของประเทศปลายทางของคุณการเดินทางของคุณจะได้รับการตรวจสอบโดยฝ่ายรักษาความปลอดภัยขององค์กร</div><div></div><br><div>กรุณา “ตอบกลับทั้งหมด” ในอีเมลและกรอกเฉพาะช่องด้านล่างและส่งอีเมลกลับไปยังผู้ส่งโดยไม่แสดงความคิดเห็นข้อมูลที่ให้ไว้จะถูกบันทึกโดยอัตโนมัติในระบบ Crisis24 Horizonจากนั้นคุณจะได้รับข้อมูลเพิ่มเติม</div><div></div><br><div>ขอบคุณ</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>ข้อมูลการเดินทาง:<div></div></strong></h3> <br><div><strong>ปลายทาง (ไซต์, เมือง):</strong></div> จุด <div><strong>ประสงค์ในการเดินทาง:</strong></div> กรณีฉ <div><strong>ุกเฉินภายในประเทศ ผู้ติดต่อ (ชื่อและหมายเลขโทรศัพท์มือถือ):</strong></div> <div><strong>โทรศัพท์มือถือของผู้เดิน</strong></div> <div><strong>ทาง: รายละเอียด</strong></div> การเดิน <div><strong>ทาง</strong></div>:<div></div> <br>',
      },
    ],
  },
  [LOCALES.UK]: {
    subject: 'Повідомлення про поїздку - Поїздка очікує затвердження',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Повідомлення про поїздку - Поїздка очікує затвердження',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Привіт <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Через класифікацію ризиків/ситуацію безпеки вашої країни призначення, ваша поїздка буде перевірена відділом корпоративної безпеки.</div> <div></div><br><div>Будь ласка, «відповісти всім» в електронній пошті та заповніть лише поля нижче, а електронний лист відправнику відправника без коментарів. Надана інформація автоматично записується в систему Crisis24 Horizon. Потім ви отримаєте додаткову інформацію.</div> <div></div><br><div>Дякую,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Інформація про поїздку:<div></div></strong></h3> <br><div><strong>Місце призначення (сайт, місто): Мета поїздки:</strong></div> <div><strong>Ек</strong></div> ст <div><strong>рений контакт у країні (ім'я та номер мобільного телефону):</strong></div> Мобільний телефон <div><strong>мандрівника: Наземний</strong></div> <div><strong>транспорт Деталі: <div><strong>Деталі проживання</strong></div>:<div></div></strong></div> <br>",
      },
    ],
  },
  [LOCALES.BG]: {
    subject: 'Известие за пътуване - пътуване в очакване на одобрение',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Известие за пътуване - пътуване в очакване на одобрение',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Здравейте <span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Поради класификацията на рискова/ситуацията със сигурността на вашата страна на дестинация, пътуването ви ще бъде проверено от отдела за корпоративна сигурност.</div> <div></div><br><div>Моля, „отговорете на всички“ в имейла и попълнете само полетата по-долу и изпратете имейла обратно на подателя без коментар. Предоставената информация автоматично се записва в системата Crisis24 Horizon. След това ще получите допълнителна информация.</div> <div></div><br><div>Благодаря ти,</div>',
      },
      {
        order: 4,
        type: 'DIVIDER',
      },
      {
        order: 5,
        type: 'TRIP_DETAILS',
      },
      {
        order: 6,
        type: 'COUNTRIES',
      },
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Информация за пътуването:<div></div></strong></h3> <br><div><strong>Дестинация (сайт, град):</strong></div> Цел на <div><strong>пътуването:</strong></div> <div><strong>Спешен контакт в страната (име и номер на мобилен телефон): Мобилен телефон на пътника:</strong></div> <div><strong>Наземен транспорт Подробности:</strong></div> <div><strong>П <div><strong>одробности за настан</strong></div> яване:<div></div></strong></div> <br>',
      },
    ],
  },
  [LOCALES.FR_CA]: {
    subject: "Avis de voyage - Voyage en attente d'approbation",
    components: [
      {order: 1, type: 'TITLE', html: "Avis de voyage - Voyage en attente d'approbation"},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bonjour <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>En raison de la classification des risques/de la situation de sécurité de votre pays de destination, votre voyage sera vérifié par le service de sécurité de l\'entreprise.</div><br><div>Veuillez « répondre à tous » dans l\'e-mail et remplir uniquement les champs ci-dessous, et renvoyer l\'e-mail à l\'expéditeur sans commentaire. Les renseignements fournis sont automatiquement enregistrés dans le système Crisis24 Horizon. Vous recevrez ensuite de plus amples informations.</div><br><div>Je vous remercie,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Informations sur le voyage :</strong></h3><br><div><strong>Destination (site, ville) :</strong></div><div><strong>But du voyage :</strong></div><div><strong>Personne-ressource d'urgence dans le pays (nom et numéro de téléphone mobile) :</strong></div><div><strong>Téléphone mobile du voyageur :</strong></div><div><strong>Renseignements sur le transport terrestre :</strong></div><div><strong>Informations sur l'hébergement :</strong></div><br>",
      },
    ],
  },
  [LOCALES.EN_GB]: {
    subject: 'Trip Notification - Trip Pending Approval',
    components: [
      {order: 1, type: 'TITLE', html: 'Trip Notification - Trip Pending Approval'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>Due to the risk classification / security situation of your destination country, your trip will be checked by the corporate security department.</div><br><div>Please “reply to all” in the e-mail and only fill in the fields below, and send the e-mail back to the sender without comment. The information provided is automatically recorded in the Crisis24 Horizon system. You will then receive further information.</div><br><div>Thank you,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Trip Info:</strong></h3><br><div><strong>Destination (site, city):</strong></div><div><strong>Trip Purpose:</strong></div><div><strong>In-Country Emergency Contact (name and mobile phone number):</strong></div><div><strong>Traveler's Mobile Phone:</strong></div><div><strong>Ground Transportation Details:</strong></div><div><strong>Lodging Details:</strong></div><br>",
      },
    ],
  },
  [LOCALES.AR]: {
    subject: 'إشعار الرحلة - الرحلة في انتظار الموافقة عليها',
    components: [
      {order: 1, type: 'TITLE', html: 'إشعار الرحلة - الرحلة في انتظار الموافقة عليها'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>مرحبًا <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>،</div><br><div>نظرًا لتصنيف المخاطر/الحالة الأمنية لبلد وجهتك، سيتم التحقق من رحلتك من قبل قسم أمن الشركة.</div><br><div>يرجى "الرد على الكل" في البريد الإلكتروني وملء الحقول أدناه فقط، وإرسال البريد الإلكتروني إلى المرسل دون تعليق. يتم تسجيل المعلومات المقدمة تلقائيًا في نظام Crisis24 Horizon. سوف تتلقى بعد ذلك مزيدًا من المعلومات.</div><br><div>شكراً لك،</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>معلومات الرحلة:</strong></h3><br><div><strong>وجهة السفر (الموقع، المدينة):</strong></div><div><strong>الغرض من الرحلة:</strong></div><div><strong>جهة الاتصال في حالات الطوارئ داخل البلد (الاسم ورقم الهاتف المحمول):</strong></div><div><strong>تفاصيل النقل البري:</strong></div><div><strong>تفاصيل السكن:</strong></div><br>',
      },
    ],
  },
  [LOCALES.PT_BR]: {
    subject: 'Notificação de viagem - Aprovação pendente de viagem',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificação de viagem - Aprovação pendente de viagem'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Olá <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>Devido à classificação de risco/situação de segurança do seu país de destino, sua viagem será verificada pelo departamento de segurança corporativa.</div><br><div>Por favor, "responda a todos" no e-mail e preencha apenas os campos abaixo, e envie o e-mail de volta ao remetente sem comentários. As informações fornecidas são automaticamente registradas no sistema Crisis24 Horizon. Em seguida, você receberá mais informações.</div><br><div>Obrigado,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Informações sobre a viagem:</strong></h3><br><div><strong>Destino (local, cidade):</strong></div><div><strong>Objetivo da viagem:</strong></div><div><strong>Contato de emergência no país (nome e número de telefone celular):</strong></div><div><strong>Telefone celular do viajante:</strong></div><div><strong>Detalhes do transporte terrestre:</strong></div><div><strong>Detalhes da hospedagem:</strong></div><br>',
      },
    ],
  },
  [LOCALES.SV]: {
    subject: 'Meddelande om resa - Väntar på godkännande av resa',
    components: [
      {order: 1, type: 'TITLE', html: 'Meddelande om resa - Väntar på godkännande av resa'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hej <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>På grund av riskklassificeringen / säkerhetssituationen i ditt destinationsland kommer din resa att kontrolleras av företagets säkerhetsavdelning.</div><br><div>Vänligen "svara på alla" i e-postmeddelandet och fyll bara i fälten nedan och skicka e-postmeddelandet tillbaka till avsändaren utan kommentarer. Den information som lämnas registreras automatiskt i Crisis24 Horizon-systemet. Du kommer då att få ytterligare information.</div><br><div>Tack,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Reseinformation:</strong></h3><br><div><strong>Destination (plats, stad):</strong></div><div><strong>Resans syfte:</strong></div><div><strong>Nödkontakt i landet (namn och mobilnummer):</strong></div><div><strong>Resenärens mobiltelefon:</strong></div><div><strong>Marktransportdetaljer:</strong></div><div><strong>Övernattningsdetaljer:</strong></div><br>',
      },
    ],
  },
  [LOCALES.FI]: {
    subject: 'Matkailmoitus - Matka odottaa hyväksyntää',
    components: [
      {order: 1, type: 'TITLE', html: 'Matkailmoitus - Matka odottaa hyväksyntää'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hei <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>Kohdemaan riskiluokituksen / turvallisuustilanteen vuoksi yrityksen turvallisuusosasto tarkistaa matkasi.</div><br><div>Kirjoita sähköpostiin "Vastaa kaikille" ja täytä vain alla olevat kentät ja lähetä sähköpostiviesti takaisin lähettäjälle ilman kommentteja. Annetut tiedot tallentuvat automaattisesti Crisis24 Horizon -järjestelmään. Saat sen jälkeen lisätietoja.</div><br><div>Kiitos,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Matkan tiedot:</strong></h3><br><div><strong>Kohde (paikka, kaupunki):</strong></div><div><strong>Matkan tarkoitus:</strong></div><div><strong>Matkalla oleva hätäyhteyshenkilö (nimi ja matkapuhelinnumero):</strong></div><div><strong>Matkustajan matkapuhelin:</strong></div><div><strong>Maankuljetuksen yksityiskohdat:</strong></div><div><strong>Majoituksen yksityiskohdat:</strong></div><br>',
      },
    ],
  },
  [LOCALES.DA]: {
    subject: 'Meddelelse om rejse - Rejse afventer godkendelse',
    components: [
      {order: 1, type: 'TITLE', html: 'Meddelelse om rejse - Rejse afventer godkendelse'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hej <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>På grund af risikoklassificeringen/sikkerhedssituationen i dit destinationsland vil din rejse blive kontrolleret af virksomhedens sikkerhedsafdeling.</div><br><div>Svar venligst "svar til alle" i e-mailen og udfyld kun felterne nedenfor, og send e-mailen tilbage til afsenderen uden kommentarer. Oplysningerne registreres automatisk i Crisis24 Horizon-systemet. Du vil derefter modtage yderligere information.</div><br><div>Tak,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Trip Info:</strong></h3><br><div><strong>Destination (sted, by):</strong></div><div><strong>Trip Purpose:</strong></div><div><strong>In-Country Emergency Contact (navn og mobilnummer):</strong></div><div><strong>Rejsendes mobiltelefon:</strong></div><div><strong>Transportoplysninger:</strong></div><div><strong>Overnatningsoplysninger:</strong></div><br>',
      },
    ],
  },
  [LOCALES.NO]: {
    subject: 'Turvarsling - Reise venter på godkjenning',
    components: [
      {order: 1, type: 'TITLE', html: 'Turvarsling - Reise venter på godkjenning'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hei <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>På grunn av risikoklassifiseringen/sikkerhetssituasjonen i destinasjonslandet ditt, blir turen sjekket av bedriftens sikkerhetsavdeling.</div><br><div>Vennligst «svar på alle» i e-posten og fyll bare ut feltene nedenfor, og send e-posten tilbake til avsenderen uten kommentar. Informasjonen som gis registreres automatisk i Crisis24 Horizon-systemet. Du vil da motta ytterligere informasjon.</div><br><div>Takk skal du ha,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Turinformasjon:</strong></h3><br><div><strong>Destinasjon (nettsted, by):</strong></div><div><strong>Turformål:</strong></div><div><strong>Nødkontakt i landet (navn og mobilnummer):</strong></div><div><strong>Reisendes mobiltelefon:</strong></div><div><strong>Bakketransportdetaljer:</strong></div><div><strong>Overnattingsdetaljer:</strong></div><br>',
      },
    ],
  },
  [LOCALES.CA]: {
    subject: "Notificació de viatge - Viatge pendent d'aprovació",
    components: [
      {order: 1, type: 'TITLE', html: "Notificació de viatge - Viatge pendent d'aprovació"},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>A causa de la classificació de risc/ situació de seguretat del teu país de destinació, el teu viatge serà revisat pel departament de seguretat corporativa.</div><br><div>Si us plau, “respongui a tots” al correu electrònic i només ompli els camps següents, i reenviï el correu electrònic al remitent sense cap comentari. La informació proporcionada es registra automàticament en el sistema Crisis24 Horizon. A continuació, rebràs més informació.</div><br><div>Gràcies,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: "<h3><strong>Informació del viatge:</strong></h3><br><div><strong>Destí (lloc, ciutat):</strong></div><div><strong>Finalitat del viatge:</strong></div><div><strong>Contacte d'emergència al país (nom i número de telèfon mòbil):</strong></div><div><strong>Telèfon mòbil del viatger:</strong></div><div><strong>Transport terrestre Detalls:</strong></div><div><strong>Detalls de l'allotjament:</strong></div><br>",
      },
    ],
  },
  [LOCALES.ES_MX]: {
    subject: 'Notificación de viaje - Viaje pendiente de aprobación',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificación de viaje - Viaje pendiente de aprobación'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><br><div>Debido a la clasificación de riesgos/situación de seguridad de tu país de destino, tu viaje será revisado por el departamento de seguridad corporativo.</div><br><div>Por favor, “responda a todos” en el correo electrónico y solo rellene los campos a continuación, y envíe el correo electrónico de vuelta al remitente sin comentarios. La información proporcionada se registra automáticamente en el sistema Crisis24 Horizon. A continuación, recibirá más información.</div><br><div>Gracias,</div>',
      },
      {order: 4, type: 'DIVIDER'},
      {order: 5, type: 'TRIP_DETAILS'},
      {order: 6, type: 'COUNTRIES'},
      {
        order: 7,
        type: 'HTML',
        html: '<h3><strong>Información del viaje:</strong></h3><br><div><strong>Destino (sitio, ciudad):</strong></div><div><strong>Propósito del viaje:</strong></div><div><strong>Contacto de emergencia en el país (nombre y número de teléfono celular):</strong></div><div><strong>Teléfono Móvil del Viajero:</strong></div><div><strong>Detalles del Transporte Terrestre:</strong></div><div><strong>Detalles del Hospedaje:</strong></div><br>',
      },
    ],
  },
};
